module.exports = __webpack_public_path__ + "static/media/advance_mobile_img.bbb685dd.png";